<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, defineExpose, onMounted } from "vue";
import {useRoute, useRouter} from 'vue-router'
import { useCookies } from 'vue3-cookies'
import jobFairGnbService from "@/pages/user/services/jobFair/jobFairGnbService";
import jobFairUserService from "@/pages/user/services/jobFair/jobFairUserService";

const route = useRoute()
const router = useRouter()

const { cookies } = useCookies();

const baseModal = ref(null);
const resolvePromise = ref(null);

const ojfIds = ref(0);
const jobDetail = ref(null);

const show = () => {
  baseModal.value.open();
  // return new Promise((resolve, _) => {
  //   resolvePromise.value = resolve;
  // });
};

const init = (ojfId) => {
  ojfIds.value = ojfId;
}

const cancel = () => {
  baseModal.value.close();
  // resolvePromise.value(false);
};

onMounted(() => {
  // 로그인 후 모달 띄우기
  const noUserViewToday = cookies.get('noUserViewToday');
  if(noUserViewToday !== 'true') {
    show();
  }

  ojfDetail();

});

const ojfDetail = () => {
  setTimeout(() => {
    const ojfId = ojfIds.value;

    jobFairGnbService.ojfGnbDetailByOjfIdAndUserID(ojfId)
        .then( async (res) => {
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            jobDetail.value = result;
          }
        }).catch( (res) =>  {
      console.log(res);
    });

  }, 150)
}

const approveYnClick = () => {
  setTimeout(() => {
    const ojfId = ojfIds.value;

    jobFairUserService.ojfUpdateEntryApproveYn(ojfId)
        .then( async (res) => {
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;

            baseModal.value.close();

            router.push({name: 'MyPageJobFairDetail', params:{id: ojfId}})
          }
        }).catch( (res) =>  {
      console.log(res);
    });
  }, 150)
}

defineExpose({
  show,
  cancel,
  init,
})
</script>
<template>
  <Modal ref="baseModal" class="vld-parent">
    <div class="modal-inner m-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body">
        <h2>참가 확정 안내</h2>
        <p>온라인 특별채용관 참가 신청이 승인되었습니다.</p>
        <div class="gray-container">
          <dl>
            <dt>행 사 명 :</dt>
            <dd v-if="jobDetail">{{ jobDetail.ojfName }}</dd>
          </dl>
          <dl>
            <dt>행사 기간 :</dt>
            <dd v-if="jobDetail">
              {{ $yyyymmdd(jobDetail.ojfStartYmd) }}({{ $dateToWeekDayShort(jobDetail.ojfStartYmd) }}) ~
              {{ $yyyymmdd(jobDetail.ojfEndYmd) }}({{ $dateToWeekDayShort(jobDetail.ojfEndYmd) }})
            </dd>
          </dl>
        </div>
      </div>
      <div class="modal-footer btn-wrap" >
        <button class="full-btn" @click="approveYnClick">행사 정보 확인</button>
      </div>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
    right: -10px !important;;
  }
  .gray-container {
    background: $gray-light_color;
    padding: 20px;
    dl {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      &:last-child {
        margin-top: 14px;
      }
      dt {
        max-width: 80px;
        width: fit-content;
        text-align: left;
      }
      dd {
        width: calc(100% - 80px);
        font-weight: 700;
        text-align: left;
      }
    }
  }
  .modal-footer {
    display: block;
  }
}
</style>